// extracted by mini-css-extract-plugin
module.exports = {"item":"DraftCreationCard_item__useQa","saleInfo":"DraftCreationCard_saleInfo__8PBua"};